import script from "./MarketCheckoutModeLivraisonForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketCheckoutModeLivraisonForm.vue?vue&type=script&setup=true&lang=ts"

import "./MarketCheckoutModeLivraisonForm.vue?vue&type=style&index=0&id=55f4afb8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f4afb8"]])

export default __exports__